import { Controller } from '@hotwired/stimulus'
import consumer from '~/javascript/channels/consumer'

// Admin support ticket detail page controller
// Handles reply type switching and real-time updates
export default class extends Controller {
  static values = {
    ticketId: String
  }

  static targets = ['messages', 'replyForm', 'messageType', 'messageBody', 'submitBtn', 'replyHint']

  connect() {
    this.subscribeToUpdates()
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  // Switch between reply and internal note modes
  setReplyType(event) {
    const replyType = event.currentTarget.dataset.replyType
    const isInternal = replyType === 'internal'

    // Update hidden input
    if (this.hasMessageTypeTarget) {
      this.messageTypeTarget.value = isInternal ? 'internal_note' : 'reply'
    }

    // Update button states
    event.currentTarget.parentElement.querySelectorAll('.tab-pill').forEach((btn) => {
      btn.classList.toggle('active', btn === event.currentTarget)
    })

    // Update submit button text
    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.textContent = isInternal ? 'Add Internal Note' : 'Send Reply'
    }

    // Update hint text
    if (this.hasReplyHintTarget) {
      this.replyHintTarget.textContent = isInternal ?
        'Only visible to staff' :
        'Customer will be notified via email'
    }

    // Update textarea placeholder
    if (this.hasMessageBodyTarget) {
      this.messageBodyTarget.placeholder = isInternal ?
        'Add an internal note (only visible to staff)...' :
        'Type your reply to the customer...'
    }
  }

  // Subscribe to ActionCable for real-time updates
  subscribeToUpdates() {
    const ticketId = this.ticketIdValue
    if (!ticketId) return

    this.subscription = consumer.subscriptions.create(
      { channel: 'SupportTicketChannel', ticket_id: ticketId },
      {
        connected: () => {
          console.log(`Connected to ticket ${ticketId}`) // eslint-disable-line no-console
        },
        disconnected: () => {
          console.log(`Disconnected from ticket ${ticketId}`) // eslint-disable-line no-console
        },
        received: (data) => {
          this.handleUpdate(data)
        }
      }
    )
  }

  handleUpdate(data) {
    switch (data.event) {
      case 'message_added':
        this.appendMessage(data.message)
        break
      case 'status_changed':
        this.updateStatus(data)
        break
      case 'internal_note_added':
        this.appendMessage(data.note)
        break
    }
  }

  appendMessage(_message) {
    // Reload page to show new message for now
    // Could be enhanced to append message dynamically
    window.location.reload()
  }

  updateStatus(_data) {
    // Reload to update status badges
    window.location.reload()
  }
}
